import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX_SIGNALS as LOCALE_PREFIX } from '../../../../../Blocks/SyntheticIndicators/constants'
import { DISTRAINTS_CODES, LINKAGES_CODES, CIA_NEWS_CODE, VIRTUAL_HEADQUOTERS, targets } from './constants'

import hocOnChange from '../../../../../../../../../../components/Ribbon/components/HocOnChange'
import hocConnect from './hocConnect'
import './style.scss'

@hocOnChange
@hocConnect
export default class CheckButton extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        disableCiaNewsBtn: PropTypes.bool,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        openLinkagesById: PropTypes.func,
        openCiaNews: PropTypes.func,
        setupDistraintsById: PropTypes.func,
        type: PropTypes.string.isRequired,
        addressBlockActive: PropTypes.bool,
        onChange: PropTypes.func,
        toggleButtonsArrayButton: PropTypes.func,
        scrollTo: PropTypes.func.isRequired,
        scrollRefs: PropTypes.object.isRequired,
    }

    handleOpenLinkagesById = () => {
        const { openLinkagesById, mainId } = this.props

        openLinkagesById(mainId)
    }

    handleSetupDistraintsById = () => {
        const { setupDistraintsById, mainId } = this.props

        setupDistraintsById(mainId)
    }

    handleCiaNewsBtnClick = () => {
        const { module, block, mainId, openCiaNews } = this.props

        openCiaNews(module, block, mainId)
    }

    handleShowAddress = () => {
        const { addressBlockActive, toggleButtonsArrayButton, onChange, setIsScrolled, scrollRefs, scrollTo, type } =
            this.props

        if (!addressBlockActive) {
            toggleButtonsArrayButton('report', 'reportBlocks', targets[type])
            onChange('report', 'reportBlocks', targets[type])
            setIsScrolled('addresses')
        } else scrollTo(scrollRefs[targets[type]])
    }

    render() {
        const { type, openLinkagesById, setupDistraintsById, openCiaNews, disableCiaNewsBtn } = this.props

        if (_.includes(DISTRAINTS_CODES, type) && setupDistraintsById) {
            return (
                <div onClick={this.handleSetupDistraintsById} className={'check-button'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.syntheticIndicators.checkDistraints`} />
                </div>
            )
        }

        if (_.includes(LINKAGES_CODES, type) && openLinkagesById) {
            return (
                <div onClick={this.handleOpenLinkagesById} className={'check-button'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.syntheticIndicators.checkLinkages`} />
                </div>
            )
        }

        if (type === CIA_NEWS_CODE && openCiaNews) {
            return (
                <div
                    onClick={this.handleCiaNewsBtnClick}
                    className={cx('check-button', disableCiaNewsBtn && 'disabled')}
                >
                    <FormattedMessage id={`${LOCALE_PREFIX}.ciaNewsCheckBtn`} />
                </div>
            )
        }

        if (type === VIRTUAL_HEADQUOTERS) {
            return (
                <div onClick={this.handleShowAddress} className={'check-button'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.syntheticIndicators.showAddress`} />
                </div>
            )
        }

        return null
    }
}
